var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddcircleGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0821 7.33337C13.0821 6.78109 12.6343 6.33337 12.0821 6.33337C11.5298 6.33337 11.0821 6.78109 11.0821 7.33337V11.0822H7.33325C6.78097 11.0822 6.33325 11.5299 6.33325 12.0822C6.33325 12.6345 6.78097 13.0822 7.33325 13.0822H11.0821V16.831C11.0821 17.3833 11.5298 17.831 12.0821 17.831C12.6343 17.831 13.0821 17.3833 13.0821 16.831V13.0822H16.8309C17.3832 13.0822 17.8309 12.6345 17.8309 12.0822C17.8309 11.5299 17.3832 11.0822 16.8309 11.0822H13.0821V7.33337Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcircleGray);
export default __webpack_public_path__ + "static/media/addcircle-gray.3e67b020600235c0a0cde799b646af3e.svg";
export { ForwardRef as ReactComponent };